export default {"src":"/_next/static/media/rerank.6cbde0af.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};